<template>
  <div class="enterpriseProfile">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>企业概况
      </span>
      <!-- <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>-->
    </div>
    <div class="enterpriseProfile-main">
      <div class="son" style="width: 55%;">
        <!-- 从业人员 -->
        <template>
          <div class="h1">从业人员</div>
          <div class="div-style col-33">企业人员总数：{{countEmployee}}人</div>
          <div ref="echartsPeople" id="myEnterPeople" :style="{width: '100%', height: '150px'}"></div>
        </template>
      </div>
      <!-- 项目信息 -->
      <div class="son" style="width: 45%;">
        <template>
          <div class="h1">诚信信息</div>
          <!-- <div class="div-style col-33" style="padding:1px 0;">
            <div style="display:flex">
              <i
                style="width:10px;height:10px;border-radius:50%;background-color:#F87CF4;display: block"
              ></i>
              <p style="width:50%; float:left;">企业不良信息：{{qybls}}次</p>
            </div>
            <div style="display:flex">
              <i
                style="width:10px;height:10px;border-radius:50%;background-color:#35D8D3;display: block"
              ></i>
              <i
                style="width:10px;height:10px;border-radius:50%;background-color:#21AAE5;display: block"
              ></i>
              <p style="width:50%;float:right;">负责人不良信息数：{{xmfzrbls}}次</p>
            </div>
          </div>-->
          <!-- <div class="div-style col-33" style="padding:1px 0;">
            <div style="display:flex">
              <i
                style="width:10px;height:10px;border-radius:50%;background-color:#FF905A;display: block"
              ></i>
              <p style="width:50%; float:left;">企业良好信息：{{qylhs}}次</p>
            </div>
            <div style="display:flex">
              <i
                style="width:10px;height:10px;border-radius:50%;background-color:#00FFFF;display: block"
              ></i>
              <i
                style="width:10px;height:10px;border-radius:50%;background-color:#51FFC1;display: block"
              ></i>
              <p style="width:50%;float:right;">负责人良好信息数：{{xmfzrlhs}}次</p>
            </div>
          </div>-->
          <div ref="echartsProject" id="myEnterProject" :style="{width: '100%', height: '200px'}"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { EmployeeExpControllerSvr } from "@/service/EmployeeExpControllerSvr";
import { IntegrityControllerSvr } from "@/service/IntegrityControllerSvr";
import commonTitle from "@/assets/js/commonTitle.js";
import { WechatNoticeMsgController } from "@/service/WechatNoticeMsgController/WechatNoticeMsgController";
import { mapState } from "vuex";
import { EnumController } from "@/service/EnumController/EnumController.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      Position: "running",
      employeeStatics: [],
      msgTypes: {},
      countEmployee: "",
      datas: [],
      dataFour: [],
      total: "",
      qybls: "",
      qylhs: "",
      xmfzrbls: "",
      xmfzrlhs: ""
    };
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {
    this.employeeExpControllerSvr = new EmployeeExpControllerSvr();
    this.integrityControllerSvr = new IntegrityControllerSvr();
    this.enumController = new EnumController();
    this.wechatNoticeMsgController = new WechatNoticeMsgController();
    this.getEnum();
    this.getEmployeeData();
  },
  mounted() {},
  methods: {
    getEmployeeData() {
      this.employeeExpControllerSvr
        .GetEmployeeStatics4RealtyCom(this.token)
        .then(res => {
          this.countEmployee = res.countEmployee;
          this.employeeStatics = res.employeeStatics;
          this.drawPeoplePie(this.$refs.echartsPeople);
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.Msg
          });
        });
      this.integrityControllerSvr
        .GetRealtyComIntegrityStatics(this.token)
        .then(res => {
          // this.qybls = res.企业不良信息数;
          // this.qylhs = res.企业良好信息数;
          // this.xmfzrbls = res.项目负责人不良信息数;
          // this.xmfzrlhs = res.项目负责人良好信息数;
          if (res.dataList.length != 0) {
            this.total = res.dataList.length;
            this.datas = res.dataList;
            for (let key in res) {
              if (key != "dataList") {
                this.dataFour.push({
                  name: key,
                  value: res[key]
                });
              }
            }
            this.drawProjectPie(this.$refs.echartsProject);
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.Msg
          });
        });
    },
    getEnum() {
      this.enumController
        .getEnum("wy.core.common.EWeChatNoticeMsgType", "")
        .then(res => {
          for (const item of res) {
            this.msgTypes[item.value] = item.label;
          }
        });
    },
    jumpMore() {
      this.$router.push("/noticeManage");
    },
    drawPeoplePie() {
      let myChartEnterprise = this.$echarts.init(this.$refs.echartsPeople);
      var chartName = ["70分以下", "70-89分", "90分以上"];
      var chartData = ["80", "17", "13"];
      var data = [];
      var legendName = [];
      for (var i = 0; i < chartData.length; i++) {
        var c = {
          value: chartData[i],
          name: chartName[i]
        };
        data[i] = c;
        legendName[i] = chartName[i];
      }
      myChartEnterprise.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
          position: function(point, params, dom, rect, size) {
            var tipHeight = point[1] + size.contentSize[1]; // contentSize: 提示dom 窗口大小
            var tipWeight = point[0] + size.contentSize[0]; // contentSize: 提示dom 窗口大小

            if (tipWeight > size.viewSize[0]) {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [
                  point[0] - size.contentSize[0],
                  point[1] - size.contentSize[1]
                ];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] - size.contentSize[0], point[1]];
              }
            } else {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [point[0] + 20, point[1] - size.contentSize[1]];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] + 20, point[1]];
              }
            }
          }
        },
        series: [
          {
            name: "从业人员",
            type: "pie",
            radius: ["30%", "55%"],
            center: ["42%", "50%"],
            clockwise: false,
            data: this.employeeStatics,
            label: {
              normal: {
                textStyle: {
                  color: "#999",
                  fontSize: 12
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                borderWidth: 4,
                borderColor: "#ffffff"
              },
              emphasis: {
                borderWidth: 0,
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ],
        color: ["#00acee", "#52cdd5", "#79d9f1", "#a7e7ff", "#c8efff"],
        backgroundColor: "#fff"
      });
    },
    drawProjectPie() {
      let myChartEnterprise = this.$echarts.init(this.$refs.echartsProject);
      var total_datas = 0;
      for (var i = 0; i < this.datas.length; i++) {
        total_datas += this.datas[i].value;
      }

      myChartEnterprise.setOption({
        color: [
          "#FF8352",
          "#E271DE",
          "#00FFFF",
          "#4AEAB0",
          "#31C5C0",
          "#1E9BD1",
          "#009D85"
        ],
        grid: {
          bottom: 150,
          left: 100,
          right: "10%"
        },
        tooltip: {
          formatter: "{a}：<br/>{b}: {c}次",
          position: function(point, params, dom, rect, size) {
            var tipHeight = point[1] + size.contentSize[1]; // contentSize: 提示dom 窗口大小
            var tipWeight = point[0] + size.contentSize[0]; // contentSize: 提示dom 窗口大小

            if (tipWeight > size.viewSize[0]) {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [
                  point[0] - size.contentSize[0],
                  point[1] - size.contentSize[1]
                ];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] - size.contentSize[0], point[1]];
              }
            } else {
              if (tipHeight > size.viewSize[1]) {
                // viewSize: echarts 容器大小
                return [point[0] + 20, point[1] - size.contentSize[1]];
              } else if (point[1] < size.contentSize[1]) {
                return [point[0] - size.contentSize[0], point[1] + 20];
              } else {
                return [point[0] + 20, point[1]];
              }
            }
          }
        },
        legend: {
          orient: "horizontal",
          left: 10,
          data: this.dataFour
        },
        series: [
          // 主要展示层的
          {
            radius: ["30%", "50%"],
            center: ["50%", "73%"],
            type: "pie",
            label: {
              normal: {
                show: true,
                formatter: "{c}次",
                textStyle: {
                  fontSize: 12
                },
                position: "outside"
              },
              emphasis: {
                show: true
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 8,
                length2: 8
              },
              emphasis: {
                show: true
              }
            },
            name: "诚信信息统计",
            data: this.dataFour
          }
        ]
      });
    },
    getdata() {
      this.wechatNoticeMsgController
        .GetNextNoticeInfo(this.token, 2)
        .then(res => {
          this.data = res._Items;
        });
    }
  }
};
</script>
<style lang="scss">
@import "./css/common.scss";
.enterpriseProfile {
  background-color: #fff;
  .enterpriseProfile-main {
    overflow: hidden;
    height: 260px;
    padding: 10px;
    display: flex;
    .son {
      padding: 0 5px;
      /* width: 50%; */
      .h1 {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        border-left: 4px solid #0f77f2;
        padding-left: 8px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 8px;
      }
      .h1:hover {
        color: #0e76f1;
      }
      .div-style {
        font-size: 14px;
        padding: 10px 0;
      }
      .py-progress {
        padding: 10px 0;
      }
    }
  }
}
</style>